"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Footer = void 0;
var _components = require("@ori-ui/components");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _contexts = require("../../contexts");
var _FormattedMessage = require("../FormattedMessage");
var _SharingWrapper = require("../SharingWrapper");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const Footer = ({
  isBasketSharingEnabled,
  isSharingButtonActive
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    miniBagConfiguration: {
      goToBasketUrl
    } = {}
  } = (0, _contexts.useMiniBagConfiguration)();
  const handleButtonClick = (0, _react.useCallback)(() => {
    window.location.href = goToBasketUrl ?? '';
  }, [goToBasketUrl]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Root, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Button, {
      fullWidth: true,
      variant: "contained",
      color: "primary",
      "data-testid": getTestId('button'),
      onClick: handleButtonClick,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormattedMessage.FormattedMessage, {
        id: "goToBasket"
      })
    }), isBasketSharingEnabled ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_SharingWrapper.SharingWrapper, {
      isSharingButtonActive: isSharingButtonActive
    }) : null]
  });
};
exports.Footer = Footer;